import { render, staticRenderFns } from "./myOrderList.vue?vue&type=template&id=386b71ae&scoped=true&"
import script from "./myOrderList.vue?vue&type=script&lang=js&"
export * from "./myOrderList.vue?vue&type=script&lang=js&"
import style0 from "./myOrderList.vue?vue&type=style&index=0&id=386b71ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b71ae",
  null
  
)

export default component.exports